import get from 'lodash/get'

export const isEnabled = (channelData) => {

  const features = get(channelData, 'features')
  if (!features) {

    return false

  }

  return !!channelData.features.find(({ name, enabled, value }) => name === 'customEmailAddress' && enabled === true && value !== 'noChannelUrl')

}
